var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.templateType === 14)?_c('reverso-msg',{attrs:{"message":_vm.message}}):(_vm.templateType === 16)?_c('node-msg',{attrs:{"message":_vm.message}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }